import { create } from "zustand";

export type ToastType = "success" | "error" | "warning" | "info";

export interface Toast {
	id: string;
	type: ToastType;
	message: string;
}

interface ToastStore {
	toasts: Toast[];
	show: (type: ToastType, message: string) => void;
	dismiss: (id: string) => void;
}

export const useToastStore = create<ToastStore>((set) => ({
	toasts: [],
	show: (type, message) => {
		const id = Math.random().toString(36).slice(2);
		set((s) => ({ toasts: [...s.toasts, { id, type, message }] }));
		setTimeout(
			() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
			4000,
		);
	},
	dismiss: (id) =>
		set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export const toast = {
	success: (msg: string) => useToastStore.getState().show("success", msg),
	error: (msg: string) => useToastStore.getState().show("error", msg),
	warning: (msg: string) => useToastStore.getState().show("warning", msg),
	info: (msg: string) => useToastStore.getState().show("info", msg),
};
